
import Vue from 'vue'
import VueScrollactive from 'vue-scrollactive'
Vue.use(VueScrollactive)

export default {
  transition: 'page',
  data () {
    return {
      howTo: [{
        id: 'edit',
        topic: 'Edit Text & Icons',
        desc: 'Let infoDiagram show you how to modify diagram graphics we designed. In this video, you can see an example of editing our PowerPoint shapes.',
        YTVideoId: 's3_i8NA0ysU',
        videoTitle: 'Watch How We Edit PowerPoint Diagram Text & Icons from infoDiagram',
        duration: 'P2MT09S',
        totalTime: 'PT3M',
        publishedAt: '2021-08-16T09:30:14Z'
      }, {
        id: 'replace',
        topic: 'How to Replace Icons in PowerPoint',
        desc: 'Let infoDiagram show you how to replace icons in our PowerPoint graphics.',
        YTVideoId: 'eC8KIQYD7O8',
        videoTitle: 'Watch How We Replaced Icons in PowerPoint – Presentation Example by infoDiagram',
        duration: 'P1MT28S',
        totalTime: 'PT2M',
        publishedAt: '2021-09-20T10:00:20Z'
      }, {
        id: 'expand',
        topic: 'How to Edit PPT Diagram Expand / Shorten',
        desc: 'Let infoDiagram show you how to modify structure of diagram (Diagram Expand / Shorten)',
        YTVideoId: 'Rj-yd0YEt6g',
        videoTitle: 'How to Edit PPT Diagram Expand / Shorten infoDiagram',
        duration: 'P2MT11S',
        totalTime: 'PT3M',
        publishedAt: '2021-08-28T15:26:45Z'
      }, {
        id: 'format',
        topic: 'Slide Size Format Change in PowerPoint',
        desc: 'Let infoDiagram show you how to effectively work with PPT graphics and change slide size format.',
        YTVideoId: 'SwNs7SzRs1U',
        videoTitle: 'Slide Size Format Change in PowerPoint',
        duration: 'P2MT09S',
        totalTime: 'PT3M',
        publishedAt: '2021-08-26T10:00:09Z'
      }]
    }
  },
  head () {
    return {
      title: 'infoDiagram - Know how'
    }
  },
  computed: {
    questions () {
      return this.howTo.map(item => ({
        question: item.topic,
        answer: item.desc,
        video: {
          description: item.desc,
          title: item.videoTitle,
          videoId: item.YTVideoId,
          videoTitle: item.videoTitle,
          duration: item.duration,
          totalTime: item.totalTime,
          publishedAt: item.publishedAt
        }
      }))
    }
  }
}
